import { render } from "./InputCateg.vue?vue&type=template&id=4740e211&scoped=true"
import script from "./InputCateg.vue?vue&type=script&lang=js"
export * from "./InputCateg.vue?vue&type=script&lang=js"

import "./InputCateg.vue?vue&type=style&index=0&id=4740e211&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4740e211"]])

export default __exports__